import http from "@/libs/http";
const dict = {
  /**获取字典数据 */
  getDictList: DictTypeList => {
    return http.post(http.formatUrl("dict/list"), DictTypeList);
  },
  /**城市列表--根据省份获取 */
  getDictListCity: Province => {
    return http.get(http.formatUrl(`dict/list/city/${Province}`));
  },
  /**根据orgId获取单位对应的大项列表 */
  getDictListDiscipline: OrgId => {
    return http.get(http.formatUrl("dict/list/discipline/orgid"), OrgId);
  },
  /**获取足球类型 */
  getDictListFootType: () => {
    return http.get(http.formatUrl("dict/list/football/type"));
  },
  /**获取字典类型列表 */
  getDictTypes: () => {
    return http.get(http.formatUrl("dict/types"));
  },
  /**获取年度列表 */
  getDictListYear: () => {
    return http.get(http.formatUrl("dict/list/year"));
  },
  /**获取年度列表（转移支付模块使用） */
  getDictListYearProvince: () => {
    return http.get(http.formatUrl("dict/list/year/province"));
  },
  /**获取年度（体育赛事备案模块使用） */
  getDictListYeargame_filing: () => {
    return http.get(http.formatUrl("game_filing/year/get"));
  },
  /**设置年度（体育赛事备案模块使用） */
  setDictListYeargame_filing: () => {
    return http.post(http.formatUrl("game_filing/year/set"));
  },
  /**单位字典列表*/
  orgDict: orgDictVO => {
    return http.get(http.formatUrl("org/dict"), orgDictVO);
  }
};
export default dict;
